import { Pipe, PipeTransform } from '@angular/core';
import { SessionService } from '../services/session.service';

@Pipe({
    name: 'hasAccess',
    standalone: true
})
export class HasAccessPipe implements PipeTransform {

	constructor(private sessionService: SessionService) {}

	transform(functional: string = '', additions: Array<string> = []): boolean {
		return this.sessionService.hasAccess(functional, additions);
	}
}
